export const OPERADOR_ROLE = 'OPERADOR';
export const GESTOR_ROLE = 'GESTOR';
export const EXTERNAL_USER_ROLE = 'usuario_externo';
export const ADMINISTRADOR = 'ADMINISTRADOR';
